import axios from "axios";
import authHeader from "./auth-header";
import { BASE_URL } from "./config";

export const login = (email, password) => {
  try {
    return axios.post(BASE_URL + "auth/login", { email, password });
  } catch (e) {
    console.log(e);
  }
};

export const createPin = (token) => {
  try {
    return axios.post(BASE_URL + "auth/createPin", { token });
  } catch (e) {
    console.log(e);
  }
};

export const validatePin = (token, pin) => {
  try {
    return axios.post(BASE_URL + "auth/validatePin", { token, pin });
  } catch (e) {
    console.log(e);
  }
};

export const getUserFirstLast = () => {
  try {
    return axios.get(BASE_URL + "feed/getUserFirstLast", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getLightDarkMode = () => {
  try {
    return axios.get(BASE_URL + "settings/getLightDarkMode", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const updateLightDarkMode = (dark_mode) => {
  try {
    return axios.post(
      BASE_URL + "settings/updateLightDarkMode",
      { dark_mode },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};
